import { ValueType } from '@/shared/config'; // Assuming this is an enum or union of string literals
import { z } from 'zod/v4';

// If ValueType is an enum or string union, create a zod schema from it — example below:
const ValueTypeDTO = z.nativeEnum(ValueType);
// or if ValueType is union of strings

export const LibsValueSchemaDTO = z.object({
  id: z.string().uuid(),
  type: ValueTypeDTO.optional(),
  value: z.any(),
  updated_at: z.string(),
});
export type LibsValueSchema = z.infer<typeof LibsValueSchemaDTO>;

export const LibsAttributeSchemaDTO: z.ZodType<any> = z.lazy(() =>
  z.object({
    attribute: LibsAttributeSchemaDTO,
    value: LibsValueSchemaDTO,
  }),
);
export type LibsAttributeSchema = z.infer<typeof LibsAttributeSchemaDTO>;

export const LibsSchemasAttributesValueSchemaDTO = z.object({
  id: z.uuid(),
  value: z.any().optional(),
});
export type LibsSchemasAttributesValueSchema = z.infer<
  typeof LibsSchemasAttributesValueSchemaDTO
>;

export const LibsAttributesVariableBaseSchemaDTO = z.object({
  id: z.uuid(),
  name: z.string(),
  value_type: z.string(),
});
export type LibsAttributesVariableBaseSchema = z.infer<
  typeof LibsAttributesVariableBaseSchemaDTO
>;

export const LibsAttributesVariableValueSchemaDTO: z.ZodType<any> = z.lazy(() =>
  z.object({
    variable: LibsAttributesVariableValueSchemaDTO,
    value: LibsSchemasAttributesValueSchemaDTO,
  }),
);
export type LibsAttributesVariableValueSchema = z.infer<
  typeof LibsAttributesVariableValueSchemaDTO
>;